import { BaseComponent } from './base';
import { FormGroup, AbstractControl, FormArray } from '@angular/forms';
import { Injector } from '@angular/core';
import { NgxLambdaUtility } from '../_utility/lambda-utility';
import { NgxUtility } from '../_utility/utility';
import { NgxValidationService } from '../../services/ngx-validation.service';

export abstract class FormBaseComponent<TModel> extends BaseComponent {

    // store current form instance
    form: FormGroup;

    private formBaseValidationService: NgxValidationService;

    constructor(formInjector: Injector) {
        super();
        this.formBaseValidationService = formInjector.get(NgxValidationService);
    }

    protected getValue(controlName: string, formGroup: FormGroup = this.form) {
        return formGroup.controls[controlName].value;
    }

    protected setValue(controlName: string, data: any, formGroup: FormGroup = this.form) {
        return formGroup.controls[controlName].setValue(data);
    }

    protected patchValue(value: Object, formGroup: FormGroup = this.form) {
        NgxUtility.patchFormValue(value, formGroup);
    }

    protected getControl(controlName: string, formGroup: FormGroup = this.form): AbstractControl {
        return formGroup.controls[controlName];
    }

    // get the form value from expression
    // !! Expermiental
    private getFormValue<S>(callbackfn: (value: TModel) => S, formGroup: FormGroup = this.form): S {
        const memberName = NgxLambdaUtility.getMemberNameFromExpression(callbackfn.toString());
        return this.getValue(memberName, formGroup) as S;
    }

    // set the form value from expression
    // !! Expermiental
    private setFormValue<S>(callbackfn: (value: TModel) => S, data: S, formGroup: FormGroup = this.form): void {
        const memberName = NgxLambdaUtility.getMemberNameFromExpression(callbackfn.toString());
        this.setValue(memberName, data, formGroup);
    }

    // get control by expression
    // !! Expermiental
    private getFormControl<S>(callbackfn: (value: TModel) => S, formGroup: FormGroup = this.form): AbstractControl {
        const memberName = NgxLambdaUtility.getMemberNameFromExpression(callbackfn.toString());
        return this.getControl(memberName, formGroup);
    }

    protected cloneFormGroup(copyForm: FormGroup, copyTo: FormGroup, clearAll: boolean = true) {
        if (clearAll) {
            Object.keys(copyTo.controls).forEach(controlName => {
                copyTo.removeControl(controlName);
            });
        }

        // copy value
        Object.keys(copyForm.controls).forEach(controlName => {
            copyTo.addControl(controlName, copyForm.controls[controlName]);
        });
    }

    // fire control validation
    fireFormControlValidation(control: AbstractControl) {
        this.formBaseValidationService.fireFormControlValidation(control);
    }

    // fire form group validation
    fireFormGroupValidation(formGroup: FormGroup = this.form) {
        this.formBaseValidationService.fireFormGroupValidation(formGroup);
    }

    // fire form arra validation
    fireFormArrayValidation(formArray: FormArray) {
        this.formBaseValidationService.fireFormArrayValidation(formArray);
    }
}